<template>
  <MapCollapseLayout>
    <slot />
  </MapCollapseLayout>
</template>
<script setup lang="ts">
</script>
